import { FC } from 'react';
import { FinanceFilterCardProps, FinanceFilterType } from './types';
import { FinanceDealDateRange } from './cards/FinanceDealDateRange';
import { FinanceSalesRep } from './cards/FinanceSalesRep';
import { FinanceLocation } from './cards/FinanceLocation';

export const financeComponentCardToTypeMapper: Record<
  FinanceFilterType,
  { label: string; component: FC<FinanceFilterCardProps> }
> = {
  [FinanceFilterType.DEAL_DATE]: { label: 'Deal Date', component: FinanceDealDateRange as any },
  [FinanceFilterType.SALES_REP]: { label: 'Sales Rep', component: FinanceSalesRep as any },
  [FinanceFilterType.LOCATION]: { label: 'Location', component: FinanceLocation as any },
};
